import React from 'react'
import { useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { formatPrice } from '@wellbeingxltd/fe-lib/helpers'
import { TransactionRow } from './TransactionRow'
import './style.scss'

const TransactionTable = ({ load, toggleTransactionToExport }) => {
    const { transactionListByMonth } = useSelector(GET_STORE.TRANSACTIONS)

    return (
        <div className="module module--withTable">
            <table className="supplierTransactionsTable">
                <thead>
                    <tr>
                        <th colSpan="2">Order (click title to fulfil)</th>
                        <th>Description</th>
                        <th>SKU</th>
                        <th>Date</th>
                        <th>Order/Transaction ID</th>
                        <th>Name</th>
                        <th>Voucher Code</th>
                        <th>Support ticket status</th>
                        <th>Status</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(transactionListByMonth).length > 0 ? (
                        <>
                            {Object.keys(transactionListByMonth).map(date => (
                                <React.Fragment key={date}>
                                    <tr className="supplierTransactionsMonth">
                                        <td colSpan="10">{date}</td>
                                    </tr>
                                    {transactionListByMonth[date].transactions.map(transaction => (
                                        <TransactionRow key={transaction.transactionId} {...{ load, toggleTransactionToExport, transaction }} />
                                    ))}
                                    <tr className="supplierTransactionsTotal">
                                        <td colSpan="12">Total: {formatPrice(transactionListByMonth[date].total)}</td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </>
                    ) : (
                        <tr className="supplierTransactionsMonth">
                            <td colSpan="10">Your orders will appear here. You don't have any at the moment.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default TransactionTable
